var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(Object.assign({}, {callback: _vm.setVisible},
    _vm.$attrs)),expression:"{\n    callback: setVisible,\n    ...$attrs\n  }"}]},[_vm._t("default",null,{"visible":_vm.visible})],2)}
var staticRenderFns = []

export { render, staticRenderFns }